export default function UpdatesSection() {
  const updates = [
    { time: '10分钟前', text: '某知名歌手深夜发文疑似回应近期争议，粉丝圈内炸开锅', tag: '新' },
    { time: '28分钟前', text: '热门IP改编剧集官宣主演阵容，书粉评论两极分化严重', tag: '热' },
    { time: '1小时前', text: '颁奖典礼后台花絮流出，两位大咖同框互动意味深长', tag: '爆' },
    { time: '2小时前', text: '综艺录制路透曝光，飞行嘉宾名单引发全网猜测', tag: '新' },
    { time: '3小时前', text: '某品牌代言人突然更换，前任代言人粉丝发起抵制话题', tag: '热' },
    { time: '5小时前', text: '新剧开机仪式现场直击，主创团队阵容豪华引期待', tag: '新' },
    { time: '7小时前', text: '音乐节演出名单陆续公布，多个重量级嘉宾确认出席', tag: '新' },
    { time: '9小时前', text: '年度热搜词榜单出炉，吃瓜爆料类话题占比再创新高', tag: '热' },
  ];

  const tagStyles: Record<string, string> = {
    '新': 'bg-primary-100 text-primary-700',
    '热': 'bg-accent-100 text-accent-800',
    '爆': 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          最新快讯
        </h2>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="flex items-start gap-4 py-4 border-b border-background-200 last:border-0 group cursor-pointer">
              <span className="text-xs text-foreground-500 whitespace-nowrap mt-0.5 min-w-[60px]">{item.time}</span>
              <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagStyles[item.tag]}`}>{item.tag}</span>
              <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed flex-1">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}